export default __webpack_public_path__ + "static/media/soundPack4.beb824a9.png";